import { inject, Injectable } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { RouterStateSnapshot, TitleStrategy } from '@angular/router'

@Injectable()
export class AppTitleStrategy extends TitleStrategy {
    private readonly title = inject(Title)

    updateTitle(snapshot: RouterStateSnapshot): void {
        // PageTitle is equal to the "Title" of a route if it's set
        // If its not set it will use the "title" given in index.html
        const pageTitle = this.buildTitle(snapshot) || this.title.getTitle()
        this.title.setTitle(`${pageTitle} | Surequote`)
    }
}
